export default {
  headerTop: 'سجّل اهتمامك لنتصل بك',
  headerAldar: 'Go to Aldar.com',
  headerRegister: 'Register your interest',
  bannerTextOne: 'EVERYTHING',
  bannerTextTwo: 'BUT ORDINARY',
  registerStory:
    'Gardenia Bay introduces a unique Yas Island lifestyle, where every day is filled with flavour. Discover waterfront studio to 3-bed apartments from AED 900K and townhouses from AED 5.5M—homes worthy of a resort in a community designed to surprise.',
  registerButton: 'Register',
  welcomeHeading: 'WELCOME TO RESORT LIVING WITH FLAIR',
  welcomeContent:
    'Wake up to inspiring waterfront views, exquisitely finished interiors and a world of surprising experiences, all infused with the energy of Yas Island. ',
  tabAmenity: 'AMENITIES',
  tabSustain: 'SUSTAINABILITY',
  tabLocation: 'LOCATION',
  amenityHeading: 'Amenities designed to surprise',
  amenityContent:
    'With an urban beach that flows into a pool, a full-scale gym, sociable spaces to work, play and practice your swing—this is a community that will always exceed expectations.',
  sustainHeading: 'A focus on sustainability',
  sustainContent: '',
  locationHeading: 'Alive with Yas Island energy',
  locationContent:
    'At the heart of Abu Dhabi’s most exciting leisure destination, Gardenia Bay is minutes from action, entertainment, leisure and adventure. While the cool Arabian Gulf and winding mangroves keep you grounded.',
  tabButton: 'Register',
  footerLink: '800 ALDAR | Aldar.com',
};
